import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77db7c0b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db7c0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77db7c0b')) {
      api.createRecord('77db7c0b', component.options)
    } else {
      api.reload('77db7c0b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77db7c0b&scoped=true", function () {
      api.rerender('77db7c0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderLock/index.vue"
export default component.exports